import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header } from './Header';
import { Footer } from './Footer';
import { StatusWidget } from './StatusWidget';
import { JsonLd } from '../JsonLd';
import { BreadcrumbJsonLd } from '../BreadcrumbJsonLd';
import { Breadcrumb } from '../Breadcrumb';
import { organizationSchema } from '../../lib/jsonld';

interface LanguageLayoutProps {
  lang: 'fr' | 'en';
}

export function LanguageLayout({ lang }: LanguageLayoutProps) {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    document.documentElement.lang = lang;
  }, [lang, i18n]);

  return (
    <>
      <JsonLd data={organizationSchema()} />
      <BreadcrumbJsonLd />
      <Header />
      <main>
        <Breadcrumb />
        <Outlet />
      </main>
      <Footer />
      <StatusWidget />
    </>
  );
}
